import { render } from "./LoginTemplate.vue?vue&type=template&id=10a0b34f"
const script = {}

import "./LoginTemplate.vue?vue&type=style&index=0&id=10a0b34f&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__